import type { UserProfile } from './authTypes'
import {
  DEMO_LOGIN_DISPLAY_NAME,
  DEMO_LOGIN_EMAIL,
  DEMO_LOGIN_UID,
  type DevLoginPersona,
} from '../config/demoAuth'

export function isRestorableDemoProfile(
  profileUid: string,
  savedAuthToken: string | null
): boolean {
  const isLegacyDemoProfile = isLegacyDemoProfileUid(profileUid)
  const isBackendDevLoginProfile =
    !import.meta.env.PROD &&
    Boolean(savedAuthToken) &&
    profileUid.startsWith('dev-login:')

  return isLegacyDemoProfile || isBackendDevLoginProfile
}

export function isLegacyDemoProfileUid(profileUid: string): boolean {
  return profileUid === DEMO_LOGIN_UID || profileUid === 'demo-user-pwc'
}

export function buildDevLoginProfile(data: {
  user: {
    uid: string
    email: string | null
    displayName: string | null
    role?: string | null
    isGlobalAdmin?: boolean
    preferences?: UserProfile['preferences']
  }
}): UserProfile {
  const now = new Date()
  const profileRole: UserProfile['role'] =
    data.user.role === 'admin' || data.user.role === 'guest'
      ? data.user.role
      : 'user'

  return {
    uid: data.user.uid,
    email: data.user.email,
    displayName: data.user.displayName,
    photoURL: null,
    role: profileRole,
    isGlobalAdmin: Boolean(data.user.isGlobalAdmin),
    createdAt: now,
    lastLoginAt: now,
    preferences: data.user.preferences || {
      theme: 'light',
      language: 'ko',
      selectedProjectId: '',
    },
  }
}

export function buildLocalDemoProfile(persona?: DevLoginPersona): UserProfile {
  const now = new Date()
  return {
    uid: persona ? `local-demo:${persona.id}` : DEMO_LOGIN_UID,
    email: persona?.email || DEMO_LOGIN_EMAIL,
    displayName: persona?.displayName || DEMO_LOGIN_DISPLAY_NAME,
    photoURL: null,
    role: persona?.projectRole === 'admin' ? 'admin' : 'user',
    isGlobalAdmin: false,
    createdAt: now,
    lastLoginAt: now,
    preferences: {
      theme: 'light',
      language: 'ko',
      selectedProjectId: '',
    },
  }
}
